

import React, { useEffect, useState } from "react";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
import CityOverview from "./CityOverview/CityOverview";
import { useLocation } from "react-router-dom";
import ReelsPlayer from "./ReelsPlayer/ReelsPlayer";

export default function LocationInsig() {
  const location = useLocation();
  // const id = location?.state?.id;

  const [openItem, setOpenItem] = useState(null); // Changed from array to single value
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [localityCounts, setLocalityCounts] = useState({});
  const [reelsForCity, setReelsForCity] = useState([]);
  const [cityDetails, setCityDetails] = useState({});
  const [isReelsPlayerOpen, setIsReelsPlayerOpen] = useState(false);
  const [selectedReel, setSelectedReel] = useState({});

  const fetchCityDetilsById = async (id) => {
    try {
      const res = await HomeService.getCityDetailsById(
        // "68720cc572a330fae27b2421"
        id,
      );
      if (res?.status) {
        setCityDetails(res?.data);
      } else {
        //  toast.error(res?.message);
        console.log(res?.data);
      }
      console.log("CITY DETAILS", res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReelsByCityId = async (id) => {
    if (!id) return;
    try {
      const res = await HomeService.getReelsByCityId(id);
      if (res?.status) {
        setReelsForCity(res?.data?.slice(0, 4));
      } else {
        console.log(res?.data);
      }
      console.log("REELS DETAILS", res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchInsights = async () => {
    setLoading(true);
    try {
      const res = await HomeService?.getPrimeLocationInsights();
      console.log("Prime Location Insights", res);
      if (res?.status) {
        setInsights(res?.data || []);

        // Fetch locality counts for all insights
        const counts = {};
        for (const insight of res.data || []) {
          if (insight.city?._id) {
            try {
              const localityRes = await HomeService?.getLocalityByCityId(
                insight.city._id,
              );
              if (localityRes?.status) {
                counts[insight.city._id] = localityRes?.data?.length || 0;
              }
            } catch (error) {
              console.error(
                `Error fetching localities for city ${insight.city._id}:`,
                error,
              );
              counts[insight.city._id] = 0;
            }
          }
        }
        setLocalityCounts(counts);
      } else {
        console.log(res);
        toast.error(res?.message || "Failed to fetch insights");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error fetching insights");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInsights();
    fetchCityDetilsById();
  }, []);

  const toggleItem = async (index, cityId) => {
    if (openItem === index) {
      // If clicking the same item, close it
      setOpenItem(null);
      setReelsForCity([]);
    } else {
      // If clicking a different item, open it and fetch reels
      setOpenItem(index);
      await fetchReelsByCityId(cityId);
    }
  };

  // Get locality count for a city
  const getLocalityCount = (cityId) => {
    return localityCounts[cityId] || 0;
  };

  if (loading) {
    return (
      <div className="accordion-container">
        <div className="city-uni-container">
          <div className="accordion_textlp">
            <h3 className="accorh3">Prime Locations & Insights</h3>
            <p className="accorp">
              Deep dive into the most sought after real estate market
            </p>
          </div>
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleCloseReelsPlayer = () => {
    setIsReelsPlayerOpen(false);
    setSelectedReel(null);
  };

  return (
    <>
      <div className="accordion-container">
        <div className="city-uni-container">
          <div className="accordion_textlp">
            <h3 className="accorh3">Prime Locations & Insights</h3>
            <p className="accorp">
              Deep dive into the most sought after real estate market
            </p>
          </div>

          {insights.length === 0 ? (
            <div className="text-center py-5">
              <p>No prime location insights available yet.</p>
            </div>
          ) : (
            <div className="accordian_lp">
              {insights?.map((insight, index) => (
                <div className="accordion-item" key={insight._id || index}>
                  <button
                    className="accordion-header"
                    onClick={() => toggleItem(index, insight?.city?._id)}
                  >
                    <div className="accordion-header_under">
                      <span className="fristl">
                        {insight?.city?.name?.charAt(0) || "C"}
                      </span>
                      {insight?.city?.name || "Unknown City"}
                    </div>
                    <div className="accordion-header_under1">
                      {/* <p>{getLocalityCount(insight?.city?._id)} Localities</p> */}
                      <p>Explore Data</p>
                      <span className="arrow">
                        {openItem === index ? (
                          <i className="fa-solid fa-angle-up"></i>
                        ) : (
                          <i className="fa-solid fa-angle-down"></i>
                        )}
                      </span>
                    </div>
                  </button>

                  {openItem === index && (
                    <div className="accordion-body">
                      <CityOverview insight={insight} />
                      <div className="highlight-header">
                        <h3 className="infoh4">
                          📸 {insight?.city?.name || cityDetails?.cityData?.name}{" "}
                          Highlights & Partners
                        </h3>
                        <a href="#" className="view-all">
                          {/* View All */}
                        </a>
                      </div>

                      <div className="highlight-cards">
                        {reelsForCity?.length > 0 ? (
                          reelsForCity?.map((e, i) => {
                            return (
                              <div
                                className="card"
                                key={e._id || i}
                                onClick={() => {
                                  setIsReelsPlayerOpen(true);
                                  setSelectedReel(e);
                                }}
                              >
                                <img
                                  src={e?.thumbnail}
                                  alt={e?.title || "Reel thumbnail"}
                                />
                                <div className="overlay-pl">
                                  <div className="playBtn-pl">
                                    <i className="fa-solid fa-play icon-pl"></i>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="col-12 text-center py-4">
                            <p>No reels available for this city yet.</p>
                          </div>
                        )}

                        {/* <div className="partner-box">
                        <div className="partner-icon">🏢</div>
                        <p className="partner-title">Become a Partner</p>
                        <p className="partner-sub">Showcase your brand here</p>
                      </div> */}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        {isReelsPlayerOpen && selectedReel && (
          <div className="reels-modal-overlay" onClick={handleCloseReelsPlayer}>
            <div
              className="reels-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="close-reels-btn"
                onClick={handleCloseReelsPlayer}
              >
                <i className="fas fa-times"></i>
              </button>
              <ReelsPlayer
                videoUrl={selectedReel?.video}
                autoPlay={true}
                muted={false}
                controls={true}
                loop={true}
              />
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        .reels-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 20px;
        }

        .reels-modal-content {
          position: relative;
          max-width: 400px;
          width: 100%;
          height:90%;
          background: #000;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
        }

        .close-reels-btn {
          position: absolute;
          top: 15px;
          right: 15px;
          background: rgba(0, 0, 0, 0.7);
          border: none;
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          transition: all 0.3s ease;
        }

        .close-reels-btn:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: scale(1.1);
        }

        .play-button-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
           background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: 12px;
        }

        .projects_div_wrapper156:hover .play-button-overlay {
          opacity: 1;
        }

        .play-icon {
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          font-size: 20px;
          transition: transform 0.3s ease;
        }

        .projects_div_wrapper156:hover .play-icon {
          transform: scale(1.1);
        }

        /* Responsive Design for Modal */
        @media (max-width: 768px) {
          .reels-modal-content {
            max-width: 350px;
          }
        }

        @media (max-width: 480px) {
          .reels-modal-content {
            max-width: 300px;
          }

          .reels-modal-overlay {
            padding: 10px;
          }
        }

        /* Ensure the project items are properly styled */
        .projects_div_wrapper156 {
          position: relative;
          transition: transform 0.3s ease;
        }

        .projects_div_wrapper156:hover {
          transform: scale(1.05);
        }
      `}</style>
    </>

  );
}
